import * as React from "react"
import type { SVGProps } from "react"
const SvgCollapseAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="m296-80-56-56 240-240 240 240-56 56-184-184zm184-504L240-824l56-56 184 184 184-184 56 56z" />
  </svg>
)
export default SvgCollapseAll
